<!-- App.svelte -->

<script>
    import { navigateTo } from 'svelte-router-spa'
    import TodoItem from "./components/TestItem.svelte";
    import { mmti_dict, pv } from "./store";

    let todos = [
        { id: 1, text: "낯선 개가 많은 환경에서는 불안해 합니다.", opacity: 1.0 },
        { id: 2, text: "먼저 말을 걸지 않으면 굳이 다가오지 않습니다.", opacity: 1.0 },
        { id: 3, text: "당신의 반려견은 공상가입니다. ", opacity: 1.0 },
        { id: 4, text: "당신이 아파하면, 당신의 반려견은 자기 일인것처럼 아파하고 당신을 간호해 줍니다.", opacity: 1.0 },
        { id: 5, text: "밖에 나가면 당신의 옆에 붙어있기 보다는 여기저기 냄새를 맡고 탐색합니다.", opacity: 1.0 },
        { id: 6, text: "당신의 반려견은 자기 이름을 알고있습니다. ", opacity: 1.0 },
        { id: 7, text: "먹을 게 보이면 일단 입에 넣고 봅니다.", opacity: 1.0 },
        { id: 8, text: "매일 하는 똑같은 놀이보다 새로운 놀이를 하는 것을 좋아합니다.", opacity: 0.0 },
    ];

    $pv = 0;
    let i = 0;
    let test_id = '';
    for (i = 0; i < todos.length; i++) {
        test_id = 'mmti' + String(todos[i].id)
        if (test_id in $mmti_dict) {
            $pv += 1;
        }
    } 

    function clickContinue() {
        let allPass = true;

        for (let i = 0; i < todos.length; i++) {
            let todo = todos[i];
            let test_id = 'mmti' + String(todo.id);

            if (test_id in $mmti_dict) {
                todos[i]['textColor'] = 'black';
                todos[i]['textAni'] = '';
            } else {
                allPass = false;
                todos[i]['textColor'] = '#ad1305';
                todos[i]['textAni'] = 'text_shake';

                setTimeout(function(){
                    todos[i]['textAni'] = '';
                }, 500);
            }
        }

        if (allPass) {
            navigateTo('test2');
        } else {
            alert('체크 안 한 항목이 있는지 한 번 더 확인해주세요.');
        } 
    }

</script>

<style lang="scss">
.hero-body {
    background: #f5f5f6;   
}

body, html {
    -webkit-tap-highlight-color: transparent; 
}

.progress {
  border-radius: 0;
}

.progress.is-mmti::-webkit-progress-value {
  background-color: rgba($color: #36765a, $alpha: 1.0);
}

.progress.is-mmti::-moz-progress-bar {
  background-color:rgba($color: #36765a, $alpha: 1.0);
}

.progress.is-mmti::-ms-fill {
  background-color:rgba($color: #36765a, $alpha: 1.0);
}

.progress.is-mmti:indeterminate {
  background-image: linear-gradient(to right, rgba($color: #36765a, $alpha: 1.0) 30%, #ededed 30%);
}
</style>

<html class="has-navbar-fixed-top" style="padding-top: 0">
<body>

<nav class="navbar is-fixed-top" style="background: #f5f5f6; min-height: 0;">
<progress class="progress is-mmti" value="{$pv}" max="40"></progress>
</nav>

<section class="hero is-fullheight">
<div class="hero-body">
<div class="container has-text-centered">
<div class="columns is-desktop">

    <div class="column">


    {#each todos as todo (todo.id)}
    <TodoItem {todo} />
    {/each}

    <div class="container">
    <figure class="image container is-128x128" style="width: 150px; cursor: pointer;" on:click={() => clickContinue() }><img src="/next.png">
    <h1 class ="title is-6 is-overlay mt-4 mr-5 has-text-white"><p>다음</p></h1>
    </figure>
    </div>

</div>
</div>
</div>
</section>
</body>
</html>
